var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "squadra_info" }, [
    _c("div", { staticClass: "d-flex pb-4 justify-space-around" }, [
      _c("div", [
        _vm._v("\n      OffertaMax "),
        _c("strong", [_vm._v(_vm._s(_vm.maxofferta))]),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n      Rimanenti "),
        _c("strong", [_vm._v(_vm._s(_vm.crediti))]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(_vm.ruoli_array, function (ruolo) {
        var _obj
        return _c(
          "span",
          {
            key: ruolo,
            staticClass: "mx-1",
            class:
              ((_obj = {
                "text--disabled": _vm.acquistiCompletati(ruolo, _vm.id_squadra),
              }),
              (_obj["Ruolo onlyLetter Ruolo_" + ruolo] = true),
              _obj),
          },
          [
            _vm._v(
              _vm._s(_vm.acquistiPerRuolo(ruolo, _vm.id_squadra)) +
                " /\n      " +
                _vm._s(_vm.prefixAcquistabiliPerRuolo()) +
                "\n      "
            ),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.acquistabiliPerRuolo(ruolo)) },
            }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }